module.exports = __webpack_public_path__ + "img/23_19.edce8606.png";